@charset "UTF-8";

/* src/app/home/comments-modal/comments-modal.component.scss */
* {
  font-family:
    "Roboto",
    Tahoma,
    Helvetica,
    sans-serif;
}
.modal-header {
  border-bottom: none;
  margin: 20px 25px 18px 25px;
  padding: 0px;
  position: relative;
}
.modal-header h4 {
  font-weight: 400;
  color: #242424;
}
.modal-body {
  margin: 0px 30px;
  padding: 0px;
}
.modal-footer {
  border-top: none;
  margin: 0px 72px;
  padding: 0px;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
}
.comments {
  max-width: 900px;
  width: 100%;
  padding-bottom: 20px;
}
textarea {
  resize: none;
  width: 100%;
  border-radius: 0;
  border: 1px solid #979797;
  min-height: 70px;
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 117px;
  height: 36px;
  font-weight: 400;
  font-size: 13px;
  margin: 32px 0px 0px 0px;
}
p {
  margin-top: 16px;
  margin-bottom: 1px;
}
.outer-container {
  height: 340px;
  border: 1px solid #6E6E6E;
  margin-top: 16px;
  margin-bottom: 10px;
}
.outer-container .header {
  background-color: #BEBEBE;
  padding: 15px 16px 16px 15px;
}
.header {
  display: flex;
  justify-content: space-between;
}
.header .refresh-container {
  position: relative;
  top: -6px;
}
.header .refresh-container .comment-refresh {
  font-size: 12px;
}
.header .refresh-container .comments-loading-bar {
  width: 168px;
  height: 10px;
}
.header .refresh-container .comments-loading-bar ::ng-deep .progress-bar {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}
.header span {
  font-size: 16px;
  font-weight: 400;
  color: #242424;
  font-family:
    "Roboto",
    Tahoma,
    Helvetica,
    sans-serif;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.comments-container {
  height: 236px;
  margin: 16px 12px;
  border: 1px solid #6e6e6e;
  overflow-y: auto;
  padding: 12px 16px;
}
.comment {
  position: relative;
  margin: 5px 0px;
}
.comment .unread-message-icon::before {
  content: "\2b24";
  position: absolute;
  top: 3px;
  left: -11px;
  color: #FFD102;
  font-size: 8px;
}
/*# sourceMappingURL=comments-modal.component.css.map */
